export default {
  focusOutline: 'focus:outline-hidden focus:ring-3 focus:ring-offset-2 focus:ring-purple-600',
  focusOutlineNoOffset: 'focus:outline-hidden focus:ring-3 focus:ring-purple-600',
  form: {
    label: 'block font-bold text-sm text-gray-700'
  },
  card: {
    base: 'bg-white border border-nl-light-color sm:rounded-3xl box-shadow'
  }
};
